import React, { useContext } from "react";
import { Link } from "react-router-dom";

import KeycloakContext from "../../../context/keycloakContext";

const DashHeader = () => {
  const { logout, tokenParsed: user } = useContext(KeycloakContext);

  return (
    <header className="header" id="header">
      <div className="header_toggle">
        <i className="bx bx-menu mx-2" id="header-toggle"></i>
      </div>

      <div className="header_user">
        <div className="header_img ml-2">
          <i className="bx bx-sm bx-user pt-1" style={{ color: "#337ab7" }}></i>
        </div>
        <Link
          className="dropdown-toggle pr-3 mt-2"
          to="#"
          id="profile"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style={{ color: "#337ab7" }}
        >
          {user.given_name ?? "Profile"}
        </Link>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="profile"
        >
          <div className="dropdown-divider"></div>
          <Link className="dropdown-item" to="/logout" onClick={() => logout()}>
            <i className="bx bx-log-out bx-xs align-middle"></i>
            Logout
          </Link>
        </div>
      </div>
    </header>
  );
};

export default DashHeader;
